import { request } from "../../../services/api"
import type { BaseApiResponse } from "../../../types/api.ts"

export const MAX_ATTACHMENTS_BYTES = 10 * 1024 * 1024

export interface MessageAttachment {
  id: string
  name: string
  size: number
  content_type?: string
  /** False when the stored file is gone or can no longer be read. */
  available?: boolean
}

export const uploadAttachment = (file: File) => {
  const formData = new FormData()
  formData.append("file", file)
  return request.api.post<
    BaseApiResponse<MessageAttachment>,
    BaseApiResponse<void>
  >("/communication/attachments/", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  })
}

export const attachmentDownloadPath = (id: string) =>
  `/communication/attachments/${id}/download/`

export const totalBytes = (items: Array<{ size: number }>) =>
  items.reduce((sum, item) => sum + (item.size || 0), 0)

export const formatBytes = (bytes: number) => {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}
